import axiosInstance from '../common/instance';

import {
  GetAllQuestionParamsTypes,
  QuestionDataResponseTypes,
  QuestionDetailParamsTypes,
  UpdateQuestionParamsTypes,
  GetAllResultParamsTypes,
  ResultDataResponseTypes,
  ResultDataDetailTypes,
  ExternalResultDataTypes,
} from './types';

export const getAllQuestionService = async (params: GetAllQuestionParamsTypes)
  : Promise<APIPaginationResponse<QuestionDataResponseTypes[]>> => {
  const res = await axiosInstance.get('survey/questions', { params });
  return res.data;
};

export const updateQuestionService = async (id: number, params: UpdateQuestionParamsTypes)
  : Promise<unknown> => axiosInstance.put(`survey/questions/${id}`, params);

export const getQuestionByIdService = async (id: number)
  : Promise<QuestionDetailParamsTypes> => {
  const res = await axiosInstance.get(`survey/questions/${id}`);
  return res.data.data;
};

export const getAllResultService = async (params: GetAllResultParamsTypes)
  : Promise<APIPaginationResponse<ResultDataResponseTypes[]>> => {
  const res = await axiosInstance.get('survey/results', { params });
  return res.data;
};

export const getResultByIdService = async (id: number)
  : Promise<ResultDataDetailTypes> => {
  const res = await axiosInstance.get(`survey/results/${id}`);
  return res.data.data;
};

export const getExternalResultByIdService = async (id: number)
  : Promise<ResultDataDetailTypes> => {
  const res = await axiosInstance.get(`survey/result-externals/${id}`);
  return res.data.data;
};

export const getExternalResultsService = async (params: GetAllResultParamsTypes)
  : Promise<APIPaginationResponse<ExternalResultDataTypes[]>> => {
  const res = await axiosInstance.get('survey/result-externals', { params });
  return res.data;
};

export const getResultClinicsService = async (params: GetAllResultParamsTypes)
  : Promise<APIPaginationResponse<ExternalResultDataTypes[]>> => {
  const res = await axiosInstance.get('survey/result-clinics', { params });
  return res.data;
};

export const getResultClinicsIdService = async (id: number)
  : Promise<ResultDataDetailTypes> => {
  const res = await axiosInstance.get(`survey/result-clinics/${id}`);
  return res.data.data;
};
